// extracted by mini-css-extract-plugin
module.exports = {"container":"Dh-z","list":"Eh-z"};